/**
 * Botón para regresar al menú principal
 */

import './HomeButton.css';

interface HomeButtonProps {
  onClick: () => void;
}

export function HomeButton({ onClick }: HomeButtonProps) {
  return (
    <button
      className="home-button"
      onClick={onClick}
      aria-label="Ver actividades"
      title="Ver actividades"
    >
      <img 
        src="/assets/chat-ui/menu.png" 
        alt="Home" 
        className="home-icon"
      />
    </button>
  );
}


